export enum ContactGroupingType {
  FOLDER = 'folder',
  LIST = 'list',
}

export const getContactGroupingItemId = (type: ContactGroupingType, id: string) => `${type}:${id}`

export type ContactGroupingItemResponse = {
  type: ContactGroupingType
  folder: { id: number } | null
  group: { id: number } | null
}
